import { NgClass, NgFor, NgIf, NgStyle, SlicePipe } from "@angular/common";
import { AfterViewInit, ChangeDetectionStrategy, Component, computed, ElementRef, EventEmitter, Input, OnChanges, Output, signal, SimpleChanges, ViewChild } from "@angular/core";
import KeenSlider from "keen-slider";
import { PlatformService } from "src/app/servicios/platform/platform.service";
import { VideoNoticiaComponent } from "../detalle-noticia/video-noticia/video-noticia.component";
import { SliderGalleryComponent } from "../slider-gallery/slider-gallery.component";
import { LeftArrowSvgComponent } from "@src/app/components/svg/arrow-left/arrow-left.component";
import { RightArrowSvgComponent } from "@src/app/components/svg/arrow-right/arrow-right.component";

@Component({
  selector: "app-slider",
  imports: [SliderGalleryComponent, VideoNoticiaComponent, SlicePipe, LeftArrowSvgComponent, RightArrowSvgComponent, NgIf, NgFor, NgClass, NgStyle],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./slider.component.html",
  styleUrl: "./slider.component.scss",
})
/**
 * Componente que muestra un slider de imagenes.
 */
export class SliderComponent implements OnChanges, AfterViewInit {
  private _images: string[] = [];
  @Input() set images(images: string[]) {
    this._images = images;
    this.initSlider();
  }

  get images(): string[] {
    return this._images;
  }
  @Input() genericAlt: string;
  @Input() gallery: boolean = false;
  @Input() noticia;
  @Input() innerHeader: boolean = false;
  @Input() headerType: 3 | 6 = 3;
  _currentIndex: number;
  @Input() set(currentIndex: number) {
    this._currentIndex = currentIndex;
    this.currentSlide.set(this.currentIndex);
    if (this.slider()) {
      this.slider().moveToIdx(this.currentIndex);
    }
  }
  @Input() currentIndex: number;
  currentSlide = signal(0);

  @Output() onLightBox = new EventEmitter();

  hidePubliVideo: boolean = false;
  rendered = computed(() => {
    if (this.slider()) {
      return true;
    } else {
      return false;
    }
  });
  slider = signal(null);
  loaded: boolean[] = [true];
  @ViewChild("videoComponent") videoComponent: any;
  @ViewChild("sliderRef") sliderRef: ElementRef<HTMLElement>;

  constructor(private platformService: PlatformService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.currentIndex) {
      this.currentSlide.set(this.currentIndex);
      if (this.slider()) {
        this.slider().moveToIdx(this.currentIndex);
      }
    }
  }

  /**
   * Inicializa el keenslider para el slider de imagenes.
   */
  initSlider() {
    if (this.platformService.isBrowser()) {
      if (this.slider()) {
        setTimeout(() => {
          this.slider.set(
            new KeenSlider(this.sliderRef.nativeElement, {
              slideChanged: (s) => {
                this.currentSlide.set(s.track.details.rel);
              },
            }),
          );
        });
      }
    }
  }

  ngAfterViewInit(): void {
    if (this.platformService.isBrowser()) {
      this.slider.set(
        new KeenSlider(this.sliderRef.nativeElement, {
          slideChanged: (s) => {
            this.currentSlide.set(s.track.details.rel);
          },
        }),
      );
    }
  }
  /**
   * Muestra el lightbox con la imagen seleccionada.
   * @param {number} int - Indice de la imagen a mostrar.
   */
  showLightbox(int: number) {
    this.onLightBox.emit(int);
  }

  /**
   * Pausa el video si se cambia de slide.
   * @param changes - Cambios en el slider.
   */
  pauseAfterChange() {
    if (this.noticia.urlVideo && this.videoComponent) {
      this.videoComponent.pauseVideo();
    }
  }

  /**
   * Cierra el video de publicidad.
   * @param video - Video a cerrar.
   */
  closeAdsVideo(video): void {
    video.pause();
    this.hidePubliVideo = true;
  }

  trackByItem(index: number, item: any) {
    return item;
  }
}
